document.addEventListener("DOMContentLoaded", function() {
  document.body.addEventListener('click', function(event) {
    if (event.target.matches('.tab-btn')) {
      event.preventDefault();
      event.stopPropagation();
      var button = event.target;
      var contentId = event.target.getAttribute('data-target');
      var content = event.target.closest('.size-chart').querySelector('[data-id="'+contentId+'"]');
	  var buttons = document.querySelectorAll('.tab-btn');
	  var contents = document.querySelectorAll('.tab-content');
      
      if (content) {
		contents.forEach(function(contentElement) {
          contentElement.classList.remove('active');
        });
        content.classList.add('active');
		buttons.forEach(function(buttonElement) {
          buttonElement.classList.remove('active');
          buttonElement.setAttribute('aria-expanded', 'false');
        });
        event.target.classList.add('active');
        event.target.setAttribute('aria-expanded', 'true');
      }
    }
  });
});